const finearts = [
  {
    title: "Mehndi",
    date: "29/09/2022",
    timing: "10:30 AM - 11:30 AM",
    venue: "Red Stairs",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      " 1.No. of participants: 1 member",
      " 2.Time: 1 hour",
      " 3.Participants are required to bring their own mehndi.",
      " 4.The mehndi must cover one hand covering both sides of the palm.",
      " 5.The mehndi must extend up to the wrist.",
      " 6.Participants are required to bring their own partner on whose hand the mehndi will be done.",
      " 7.High lighteners are not allowed.",
    ],
  },
  {
    title: "Tattoo making",
    date: "29/09/2022",
    timing: "11:30 AM - 12:00 PM",
    venue: "Red Stairs",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      " 1.No. of participants: 1 member",
      " 2.Tattoo making area- upper portion of arm (shoulder to elbow.)",
      " 3.Time limit: 30 minutes",
      " 4.Arrangements of all the materials have to be done by participants.",
      " 5.Participants are required to bring their partner on whose arm the tattoo will be designed.",
      " 6.Theme will be disclosed 30 minutes before the competition.",
    ],
  },
  {
    title: "Rangoli",
    date: "29/09/2022",
    timing: "12:05 PM - 01:05 PM",
    venue: "Red Stairs",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      " 1.No. of participants: 2 member",
      " 2.Time: 1 hour",
      " 3.Participants are required to bring their own colours accordingly.",
      " 4.Theme will be disclosed 30 minutes before the competition.",
      " 5.Only powdered colours are allowed.",
      " 6.No patterns are allowed.",
    ],
  },
  {
    title: "Pot Painting",
    date: "29/09/2022",
    timing: "01:10 PM - 02:40 PM",
    venue: "Red Stairs",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      " 1.No. of participants: 1 member",
      " 2.Time: 1 hour 30 minutes",
      " 3.Participants are required to bring their own material for decoration, colours etc.",
      " 4.Pots will be provided by the college.",
      "   NOTE: Maximum 15 participants are allowed which will be based on first come first basis",
    ],
  },
  {
    title: "Sketching",
    date: "29/09/2022",
    timing: "02:45 PM - 03:30 PM",
    venue: "1F-12",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      " 1.No. of participants: 1 member",
      " 2.Time: 45 minutes",
      " 3.Topic for the sketching will be disclosed 30 minutes before the competition.",
      " 4.Participants are required to bring their own stationary, only drawing sheet will be provided by the college.",
      " 5.Colours are not allowed.",
      " 6.Sketching must be self explanatory. Participants would not be allowed for any description.",
    ],
  },

  // {
  //   title: "Talkative Cartoon",
  //   // date: "29/09/2022",
  //   bgColor: "blue",
  //   tag: "red",
  //   linkUrl:
  //     "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
  //   linkText: "Read Rules",
  //   rules: [
  //     " 1.No of participant individual.",
  //     " 2.Time period- 1 Hour.",
  //     " 3.Theme will be disclosed on the spot.",
  //     " 4.Participants are required to bring their own material(like pencil, eraser, colours, etc.)",
  //   ],
  // },
  {
    title: "Nail Art",
    date: "29/09/2022",
    timing: "03:30 PM - 04:00 PM",
    venue: "Red Stairs",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      " 1.No of participant: 1 member",
      " 2.Time period -30 minutes",
      " 3.No theme",
      " 4.Participants are required to bring their partner on whose nail art is to be done.",
      " 5.Participants are required to bring their accessories and material.",
    ],
  },
  {
    title: "Salad Carving",
    date: "29/09/2022",
    timing: "03:00 PM - 03:30 PM",
    venue: "1F-09",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      " 1.Time period – 30 minutes",
      " 2.No of participant in a team- 2 members",
      " 3.Any sort of vegetables/ fruits can be used.",
      " 4.Bring all materials yourself. (vegetables, fruits, serving dish, knife etc)",
      " 5.Artificial items and synthetic colors are not allowed.",
      " 6.Candidates have to bring raw materials only.",
    ],
  },
  {
    title: "Clay Art",
    date: "29/09/2022",
    timing: "03:35 PM - 04:35 PM",
    venue: "1F-09",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      " 1.No of participants in a team: 1 member.",
      " 2.Time period: 45 minutes",
      " 3.Only clay can be used for designing.",
      " 4.Participants are required to bring their own material.",
    ],
  },
  {
    title: "Best Shot",
    date: "29/09/2022",
    timing: "10:30 AM - 04:00 PM",
    venue: "  ",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      " 1.No. of participants per team: 1 member",
      " 2.Participants have to register with their digital camera.",
      " 3.Photographs only from institute campus with dated________ should be submitted.",
      " 4.Participant must ensure that the registered photograph is taken by him / her only else his/ her participation will be cancel.",
      " 5.Digital manipulations and adjustments are not allowed (no Photoshop or any software effects allowed).",
      " 6.Full Day (10:30 a.m. to 3.30 p.m.) will be given to the participants.",
    ],
  },
  {
    title: "Hobby Collection",
    date: "30/09/2022",
    timing: "10:00 AM - 10:30 AM",
    venue: "1F-09",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      " 1.No of participants: 1 member",
      " 2.Time period: 1 hour",
      " 3.Participants are required to bring their collection.",
      " 4.Judges would also do the questionnaire round regarding the collection they have bought.",
    ],
  },
 
  {
    title: "Hair Styling",
    date: "30/09/2022",
    timing: "10:40 AM - 11:10 AM",
    venue: "Red Stairs",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      " 1.No of participants: 1 member",
      " 2.Time period: 30 minutes",
      " 3.Participants are required to bring their partner on whom hair styling will be done.",
      " 4.Participants are required to bring their accessories and material.",
    ],
  },
  {
    title: "T-Shirt Painting",
    date: "30/09/2022",
    timing: "11:15 AM - 12:15 PM",
    venue: "Red Stairs",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "1.No of participants in a team: 1 member",
      "2.Time period: 45 minutes",
      "3.Theme will be disclosed on the spot.",
    ],
  },
  {
    title: "Face Painting",
    date: "30/09/2022",
    timing: "12:20 PM - 01:05 PM",
    venue: "Red Stairs",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "1.No. of participants: 2 member",
      "2.Time: 45 minutes",
      "3.Participants are required to bring their own colours.",
      "4.Participants are required to bring their partner on whose face the painting will be done.",
    ],
  },
  {
    title: "Cook Without Fire",
    date: "30/09/2022",
    timing: "11:30 AM - 12:30 PM",
    venue: "1F-09",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "1.No. of participants per team: 2 members",
      "2.Time: 1 hour",
      "3.Participants are required to bring their own material as per their requirement.",
      "4.Boiled food from home is not allowed (like boiled potatoes, boiled dal etc.)",
    ],
  },
  {
    title: "Soap Carving",
    date: "30/09/2022",
    timing: "01:10 PM - 02:10 PM",
    venue: "Red Stairs",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "1.No of participants in a team- 1 member",
      "2.Time period -1 Hour",
      "3.Participants need to carve the object given on the spot.",
      "4.Participants are required to bring their material except soap which will be provided.",
      "NOTE: Maximum 15 participants are allowed which will be based on first come first basis.",
    ],
  },
  {
    title: "Collage Making",
    date: "30/09/2022",
    timing: "02:15 PM - 03:15 PM",
    venue: "Red Stairs",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "1.No. of participants: 2 members",
      "2.Theme will be Positive & Negative Aspects of Covid.",
      "3.Time: 1 hour",
      "4.Participants are required to bring Newspapers, glue, scissors, colours, chart paper, thermocol, etc.",
      "5.Participants will have to potray their collage to the judges at the end of the competition.",
      "NOTE: ONLY NEWSPAPER CUTTINGS ARE ALLOWED (Print outs, cuttings from Magazines etc. are not allowed.)",
    ],
  },
  {
    title: "Best out of Scrap",
    date: "30/09/2022",
    timing: "03:20 PM - 04:20 PM",
    venue: "Red Stairs",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "1.No. of participants: 1 member",
      "2.Time: 1 hour",
      "3.Theme will be disclosed on the spot.",
      "4.Participants are required to bring their own glue, scissors, colours, etc.",
      "5.The waste/scrap material will be provided by the college.",
    ],
  },
  {
    title: "Movie Making",
    date: "30/09/2022",
    timing: "10:30 AM - 04:00 PM",
    venue: " ",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "1.No. of participants per team: 4 members(Maximum).",
      "2.Participants should register with their digital camera.",
      "3.Dated Videos only from institute campus should be submitted.",
      "4.Digital manipulations and adjustments are not allowed (no Photoshop or any software effects allowed) .",
      "5.Full Day (10:30AM to 3:00 PM) will be given to the participants.",
    ],
  },
  // {
  //   title: "Mosaic",
  //   // date: "29/09/2022",
  //   bgColor: "blue",
  //   tag: "red",
  //   linkUrl:
  //     "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
  //   linkText: "Read Rules",
  //   rules: [
  //     "1.No of participants in a team- 1 member",
  //     "2.Time period - 1 Hour",
  //     "3.Only glass pieces can be used for designing.",
  //     "4.Participants are required to bring their own material",
  //   ],
  // },
  
];
export default finearts;
